import { Post } from '../helpers';

export function UpdateFavicon(project_uuid: string, favicon?: string | null): Promise<{ favicon: string }> {
  return Post({
    path: `/v3/admin/events/favicon/${project_uuid}`,
    body: { favicon },
  });
}
